(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-upcoming-events"] && !Shopify.designMode) return;
  try {
    
  class EventRow extends HTMLElement {
    connectedCallback() {
      const main = this.querySelector('.event-row__main');
      const btn = this.querySelector('.event-row__toggle');
      const panel = this.querySelector('.event-row__expandable');
      const banner = this.querySelector('.event-row__banner');
      if (!main || !btn || !panel) return;

      const toggle = (e) => {
        if (e.target.closest('a')) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      };

      main.style.cursor = 'pointer';
      main.addEventListener('click', toggle);

      if (banner) {
        banner.style.cursor = 'pointer';
        banner.addEventListener('click', toggle);
      }
    }
  }

  if (!customElements.get('event-row')) {
    customElements.define('event-row', EventRow);
  }

  } catch(e) { console.error(e); }
})();
})();
